import { Navigate, Route, Routes } from "react-router-dom";
import MainNav from "./navigation/protected/MainNav";
import NotFoundPage from "./pages/NotFoundPage";
import RedirectPage from "./pages/auth/RedirectPage";
import DeniedPage from "./pages/auth/DeniedPage";
import ScrollToTop from "./components/ui/ScrollToTop";
import LoginPage from "./pages/auth/LoginPage";
import { initCustomAlerts } from "./helpers/alertError";
import ProductSelectPage from "./pages/ProductSelectPage";
import NewSitePage from "./pages/module-pages/sites/NewSitePage";

function App() {
  // Initialiser le remplacement des alerts
  initCustomAlerts();
  return (
    <>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/redirect" element={<RedirectPage />} />
          <Route path="/denied" element={<DeniedPage />} />
          <Route path="/select-product" element={<ProductSelectPage />} />
          <Route path="/new-product" element={<NewSitePage />} />

          <Route path="/admin/*" element={<MainNav />} />

          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </ScrollToTop>
    </>
  );
}

export default App;
